import React, { memo, useMemo } from "react";
import { validators } from "investira.sdk";
import {
  Stack,
  Typography,
  CircularProgress,
  Divider,
  Box,
} from "investira.react.components";
import { IndicadorTemplate } from "../../components/templates";
import {
  SearchIndicadores,
  SearchPrincipal,
  SearchGlobal,
} from "../../components/organisms";
import { useIndicadoresContext } from "../../contexts/IndicadoresContext";
import IndicadoresCotacao from "./IndicadoresCotacao";
import IndicadoresTabular from "./IndicadoresTabular";
import IndicadorHeader from "./IndicadorHeader";

const Indicador = memo(() => {
  const { state } = useIndicadoresContext();
  const { dataInicio, dataFim, indicador, isPageLoading } = state;

  const xIndicadorCotacaoData = useMemo(() => {
    return [
      {
        indicador: indicador.current.indicador_id,
        data: indicador.historico.full,
      },
    ];
  }, [indicador.current.indicador_id, indicador.historico.full]);

  if (isPageLoading) {
    return (
      <Stack sx={{ height: "100%" }}>
        <Stack justifyContent="center" alignItems="center" flexGrow={1}>
          <CircularProgress />
        </Stack>
      </Stack>
    );
  }

  if (validators.isEmpty(indicador.historico)) {
    return (
      <Stack sx={{ height: "100%" }}>
        <Stack justifyContent="center" alignItems="center" flexGrow={1}>
          <Typography variant="body2" color="textSecondary">
            Indicador não encontrado
          </Typography>
        </Stack>
      </Stack>
    );
  }

  return (
    <IndicadorTemplate
      title={`${indicador.current.indicador_id || ""} - ${
        indicador.current.indicador || ""
      } - Indicador
      `}
      header={<IndicadorHeader compare={false} />}
      description={`Descubra tudo sobre ${indicador.indicador}`}
      searchComponent={<SearchGlobal />} // SearchIndicadores
      maxWidth="xl"
    >
      <Stack py={2}>
        <Divider />
      </Stack>

      <Stack gap={4}>
        <IndicadoresCotacao
          indicador={indicador.current.indicador_id}
          cotacoes={xIndicadorCotacaoData}
        />
        <IndicadoresTabular
          dataInicio={dataInicio}
          dataFim={dataFim}
          indicador={indicador.current}
          cotacoes={xIndicadorCotacaoData}
        />
      </Stack>
    </IndicadorTemplate>
  );
});

Indicador.displayName = "IndicadorOverview";

export default Indicador;
